<div class="security-page">
    <sync-list [ListItems]="securityFeatures"></sync-list>

    <app-dialog-twofactor *ngIf="showTwoFactorDialog" [(showTwoFactorDialog)]="showTwoFactorDialog" [user]="user"></app-dialog-twofactor>
    <app-dialog-password-hint *ngIf="showPasswordHintDialog" [(showPasswordHintDialog)]="showPasswordHintDialog" [user]="user"></app-dialog-password-hint>
    <app-dialog-password-recovery *ngIf="showPasswordRecoveryDialog" [(showPasswordRecoveryDialog)]="showPasswordRecoveryDialog" [user]="user"></app-dialog-password-recovery>
</div>